import { computed, Ref } from "vue"
import { useI18n } from "vue-i18n"

export function usePasswordStrenght(password: Ref<string>) {
  const { t } = useI18n()

  const checkStrength = (pass: string) => {
    const requirements = [
      { regex: /[^a-zA-Z0-9 ]/, text: t('At least 1 special character') },
      { regex: /.{6,}/, text: t('At least 6 characters') },
      { regex: /[0-9]/, text: t('At least 1 number') },
      { regex: /[a-z]/, text: t('At least 1 lowercase letter') },
      { regex: /[A-Z]/, text: t('At least 1 uppercase letter') },
    ]



    return requirements.map((req) => ({
      met: req.regex.test(pass),
      text: req.text,
    }))
  }

  const strength = computed(() => checkStrength(password.value))

  const strengthScore = computed(() => {
    return strength.value.filter((req) => req.met).length
  })

  const getStrengthColor = (score: number) => {
    if (score === 0) return 'bg-border'
    if (score <= 1) return 'bg-red-500'
    if (score <= 2) return 'bg-orange-500'
    if (score === 3) return 'bg-amber-500'
    return 'bg-emerald-500'
  }

  const getStrengthText = (score: number) => {
    if (score === 0) return t('Enter a password')
    if (score <= 2) return t('Weak password')
    if (score === 3) return t('Medium password')
    return t('Strong password')
  }

  return {
    strength,
    strengthScore,
    getStrengthColor,
    getStrengthText,
  }
}